import * as React from 'react';
import { Button, Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import { DocumentSubmittedSuccessMessage } from './DocumentSubmittedSuccessMessage';

export interface DocumentSubmittedModalProps {
	documentName?: string;
	onDone: () => void;
}

export const DocumentSubmittedModalComponent: React.FC<
	DocumentSubmittedModalProps
> = ({ documentName, onDone }) => {
	return (
		<div className="flex w-full max-w-full min-w-0 flex-col items-center text-center">
			<Icon
				src={Icons.checkCircleEmptyState}
				width={160}
				height={160}
				className="size-[160px]"
			/>
			<Typography type="semibold-20" id="document-submitted-title">
				Document Submitted
			</Typography>
			<DocumentSubmittedSuccessMessage
				documentName={documentName}
				className="mt-6"
			/>
			<Button
				type="button"
				size="fit"
				decoration="secondary"
				label="Done"
				onClick={onDone}
				className="mt-6"
			/>
		</div>
	);
};

export default DocumentSubmittedModalComponent;
